(function(){
const variants = JSON.parse(document.getElementById('lgw-variants-json').textContent);
const currency = JSON.parse(document.getElementById('lgw-currency-json').textContent);
const state = {
width: '16"',
lines: '1 Line',
fonts: [
{ name: 'Cursive', family: "'Sacramento', cursive" },
{ name: 'Cursive', family: "'Sacramento', cursive" },
{ name: 'Cursive', family: "'Sacramento', cursive" }
],
colors: [
{ name: 'White', value: '#ffffff' },
{ name: 'White', value: '#ffffff' },
{ name: 'White', value: '#ffffff' }
],
sizes: [100, 100, 100],
backing: 'Clear',
backingClass: 'backing-clear',
mounting: 'Hanging (Chain)'
};
const board =
document.getElementById('lgw-board');
const previewText =
document.getElementById('lgw-preview-text');
const backingCanvas=document.createElement('canvas');
backingCanvas.className='lgw-backing-canvas';
board.insertBefore(backingCanvas,previewText);
let backingFrame=null;
const inputs = [
document.getElementById('lgw-text-1'),
document.getElementById('lgw-text-2'),
document.getElementById('lgw-text-3')
];
const previews = [
document.getElementById('lgw-preview-1'),
document.getElementById('lgw-preview-2'),
document.getElementById('lgw-preview-3')
];
const wrappers = [
null,
document.getElementById('lgw-text-wrap-2'),
document.getElementById('lgw-text-wrap-3')
];
const counters = [
document.getElementById('lgw-count-1'),
document.getElementById('lgw-count-2'),
document.getElementById('lgw-count-3')
];
const sizeSliders = [
document.getElementById('lgw-size-1'),
document.getElementById('lgw-size-2'),
document.getElementById('lgw-size-3')
];
const sizeValues = [
document.getElementById('lgw-size-value-1'),
document.getElementById('lgw-size-value-2'),
document.getElementById('lgw-size-value-3')
];
const priceEl =
document.getElementById('lgw-price');
const summaryEl =
document.getElementById('lgw-selection-summary');
const addButton =
document.getElementById('lgw-add');
const message =
document.getElementById('lgw-message');
const quantity =
document.getElementById('lgw-quantity');
const measurementCanvas =
document.createElement('canvas');
const measurementContext =
measurementCanvas.getContext('2d');
let fitFrame = null;

const designFonts = [
'Cursive',
'Script',
'Sleek',
'Modern',
'Neon',
'Rounded',
'Audiowide',
'League Spartan'
];
const designColors = [
'White',
'Red',
'Blue',
'Green',
'Pink',
'Purple',
'Orange',
'Yellow',
'Ice Blue',
'Golden'
];
const designWidths = [
'16"',
'20"',
'24"',
'28"',
'32"'
];
const designBackings = [
'Clear',
'Glossy Black',
'Glossy White'
];
const designMountings = [
'Hanging (Chain)',
'Wall Mount (Holes & Screws)'
];

function encodeDesignPayload(payload){
const json =
JSON.stringify(payload);
const bytes =
new TextEncoder().encode(json);
let binary = '';
bytes.forEach(function(byte){
binary +=
String.fromCharCode(byte);
});
return btoa(binary)
.replace(/\+/g, '-')
.replace(/\//g, '_')
.replace(/=+$/g, '');
}

function decodeDesignPayload(value){
let base64 =
value
.replace(/-/g, '+')
.replace(/_/g, '/');
while(base64.length % 4){
base64 += '=';
}
const binary =
atob(base64);
const bytes =
new Uint8Array(binary.length);
for(let i = 0; i < binary.length; i++){
bytes[i] =
binary.charCodeAt(i);
}
const json =
new TextDecoder().decode(bytes);
return JSON.parse(json);
}

function buildCustomerDesignUrl(total){
const payload = [
1,
total,
designWidths.indexOf(state.width),
inputs[0].value.trim(),
total >= 2 ? inputs[1].value.trim() : '',
total >= 3 ? inputs[2].value.trim() : '',
designFonts.indexOf(state.fonts[0].name),
total >= 2 ? designFonts.indexOf(state.fonts[1].name) : 0,
total >= 3 ? designFonts.indexOf(state.fonts[2].name) : 0,
designColors.indexOf(state.colors[0].name),
total >= 2 ? designColors.indexOf(state.colors[1].name) : 0,
total >= 3 ? designColors.indexOf(state.colors[2].name) : 0,
designBackings.indexOf(state.backing),
designMountings.indexOf(state.mounting),
state.sizes[0],
total >= 2 ? state.sizes[1] : 100,
total >= 3 ? state.sizes[2] : 100
];
const url =
new URL(
window.location.origin +
window.location.pathname
);
url.searchParams.set(
'design',
encodeDesignPayload(payload)
);
return url.toString();
}

function selectButtonByData(selector, attribute, value){
const buttons =
Array.from(
document.querySelectorAll(selector)
);
const match =
buttons.find(function(button){
return button.dataset[attribute] === value;
});
if(!match){
return null;
}
buttons.forEach(function(button){
button.classList.remove('selected');
});
match.classList.add('selected');
return match;
}

function restoreCustomerDesignFromUrl(){
const params =
new URLSearchParams(
window.location.search
);
const encoded =
params.get('design');
if(!encoded){
return;
}
try{
const payload =
decodeDesignPayload(encoded);

if(
!Array.isArray(payload) ||
payload[0] !== 1
){
return;
}

const total =
Math.min(
3,
Math.max(
1,
parseInt(payload[1], 10) || 1
)
);

const width =
designWidths[payload[2]] ||
designWidths[0];

state.lines =
total === 1 ?
'1 Line' :
total + ' Lines';
state.width =
width;

inputs[0].value =
String(payload[3] || '');
inputs[1].value =
String(payload[4] || '');
inputs[2].value =
String(payload[5] || '');

const lineButton =
selectButtonByData(
'#lgw-line-buttons .lgw-choice',
'value',
state.lines
);
const widthButton =
selectButtonByData(
'#lgw-width-buttons .lgw-choice',
'value',
state.width
);

for(let i = 0; i < 3; i++){
const fontName =
designFonts[payload[6 + i]] ||
designFonts[0];
const fontButton =
Array.from(
document.querySelectorAll(
'.lgw-font[data-line="' +
(i + 1) +
'"]'
)
).find(function(button){
return button.dataset.name === fontName;
});
if(fontButton){
fontButton
.closest('.lgw-font-grid')
.querySelectorAll('.lgw-font')
.forEach(function(button){
button.classList.remove('selected');
});
fontButton.classList.add('selected');
state.fonts[i] = {
name: fontButton.dataset.name,
family: fontButton.dataset.family
};
}

const colorName =
designColors[payload[9 + i]] ||
designColors[0];
const colorButton =
Array.from(
document.querySelectorAll(
'.lgw-color[data-line="' +
(i + 1) +
'"]'
)
).find(function(button){
return button.dataset.name === colorName;
});
if(colorButton){
colorButton
.closest('.lgw-color-grid')
.querySelectorAll('.lgw-color')
.forEach(function(button){
button.classList.remove('selected');
});
colorButton.classList.add('selected');
state.colors[i] = {
name: colorButton.dataset.name,
value: colorButton.dataset.color
};
}
}

for(let i = 0; i < 3; i++){
const restoredSize =
parseInt(payload[14 + i], 10);
state.sizes[i] =
restoredSize >= 60 && restoredSize <= 140 ?
restoredSize :
100;
sizeSliders[i].value =
String(state.sizes[i]);
sizeValues[i].textContent =
state.sizes[i] + '%';
}
const backingName =
designBackings[payload[12]] ||
designBackings[0];
const backingButton =
Array.from(
document.querySelectorAll('.lgw-backing')
).find(function(button){
return button.dataset.name === backingName;
});
if(backingButton){
setSelected(
'.lgw-backing',
backingButton
);
state.backing =
backingButton.dataset.name;
state.backingClass =
backingButton.dataset.class;
}

const mountingName =
designMountings[payload[13]] ||
designMountings[0];
const mountingButton =
Array.from(
document.querySelectorAll('.lgw-mounting')
).find(function(button){
return button.dataset.name === mountingName;
});
if(mountingButton){
setSelected(
'.lgw-mounting',
mountingButton
);
state.mounting =
mountingButton.dataset.name;
}

}catch(error){
console.warn(
'Unable to restore customer design.',
error
);
}
}
function scalePreviewBoard(){
const stage =
document.getElementById('lgw-preview-stage');
if(!stage || !board){
return;
}
const stageStyles =
window.getComputedStyle(stage);
const leftPadding =
parseFloat(stageStyles.paddingLeft) || 0;
const rightPadding =
parseFloat(stageStyles.paddingRight) || 0;
const availableWidth =
Math.max(
100,
stage.clientWidth -
leftPadding -
rightPadding
);
const scale =
Math.min(
1,
availableWidth / 740
);
board.style.transform =
'translate(-50%, -50%) scale(' + scale + ')';
}
function lineCount(){
if(state.lines === '3 Lines'){
return 3;
}
if(state.lines === '2 Lines'){
return 2;
}
return 1;
}
function limits(w){
var m=w==='16"'?8:(w==='20"'?10:(w==='24"'||w==='28"'?12:14)),b=0,n=lineCount();
document.querySelector('#lgw-builder-v10 .lgw-helper').textContent='Maximum '+m+' characters per line.';
inputs.forEach(function(x,i){x.maxLength=m;counters[i].nextSibling.nodeValue=' / '+m;if(i<n&&x.value.length>m)b=i+1;});
if(b){message.style.color='#a00';message.textContent=w+' signs allow up to '+m+' characters per line. Please shorten Line '+b+'.';}
else if(message.textContent.indexOf('characters per line')>-1)message.textContent='';
var v=findVariant();addButton.disabled=!!b||!v||!v.available;
}
function findVariant(){
return variants.find(function(variant){
return (
variant.options.includes(state.width) &&
variant.options.includes(state.lines)
);
});
}
function money(cents){
try{
return new Intl.NumberFormat(
'en-US',
{
style: 'currency',
currency: currency
}
).format(cents / 100);
}catch(e){
return '$' +
(cents / 100).toFixed(2);
}
}
function setSelected(selector, button){
document
.querySelectorAll(selector)
.forEach(function(item){
item.classList.remove('selected');
});
button.classList.add('selected');
}
function updateVariant(){
const variant =
findVariant();
summaryEl.textContent =
state.width +
' wide · ' +
state.lines;
if(!variant){
priceEl.textContent =
'Unavailable';
addButton.disabled =
true;
return;
}
priceEl.textContent =
money(variant.price);
addButton.disabled =
!variant.available;
}

function backingText(ctx,e,br,scale){
const s=getComputedStyle(e),text=e.textContent||'',fs=parseFloat(s.fontSize)||60;
let sx=1;
try{if(s.transform&&s.transform!=='none')sx=Math.abs(new DOMMatrixReadOnly(s.transform).a)||1}catch(q){}
const b=e.getBoundingClientRect(),y=((b.top+b.bottom)/2-br.top)/scale,ls=parseFloat(s.letterSpacing)||0;
ctx.save();ctx.translate(board.offsetWidth/2,y);ctx.scale(sx,1);ctx.font=(s.fontWeight||500)+' '+fs+'px '+s.fontFamily;
ctx.textAlign='center';ctx.textBaseline='middle';ctx.lineJoin='round';ctx.lineCap='round';
if(!ls){ctx.fillText(text,0,0);ctx.strokeText(text,0,0)}
else{const a=Array.from(text),w=a.map(ch=>ctx.measureText(ch).width),tw=w.reduce((p,v)=>p+v,0)+ls*Math.max(0,a.length-1);let x=-tw/2;ctx.textAlign='left';a.forEach(function(ch,i){ctx.fillText(ch,x,0);ctx.strokeText(ch,x,0);x+=w[i]+ls})}
ctx.restore();
}
function fillMaskHoles(c){
const g=c.getContext('2d'),im=g.getImageData(0,0,c.width,c.height),p=im.data,W=c.width,H=c.height,seen=new Uint8Array(W*H),qx=new Int32Array(W*H),qy=new Int32Array(W*H);let h=0,t=0;
function add(x,y){if(x<0||y<0||x>=W||y>=H)return;let j=y*W+x;if(seen[j]||p[j*4+3])return;seen[j]=1;qx[t]=x;qy[t]=y;t++}
for(let x=0;x<W;x++){add(x,0);add(x,H-1)}for(let y=1;y<H-1;y++){add(0,y);add(W-1,y)}
while(h<t){let x=qx[h],y=qy[h++];add(x+1,y);add(x-1,y);add(x,y+1);add(x,y-1)}
for(let y=0;y<H;y++)for(let x=0;x<W;x++){let j=y*W+x;if(!p[j*4+3]&&!seen[j])p[j*4+3]=255}
g.putImageData(im,0,0)
}
function actualLineWidth(i){
const e=previews[i],s=getComputedStyle(e),t=e.textContent||'',fs=parseFloat(s.fontSize)||60,ls=parseFloat(s.letterSpacing)||0;
measurementContext.font=(s.fontWeight||500)+' '+fs+'px '+s.fontFamily;
let w=measurementContext.measureText(t).width+ls*Math.max(0,Array.from(t).length-1);
try{if(s.transform&&s.transform!=='none')w*=Math.abs(new DOMMatrixReadOnly(s.transform).a)||1}catch(q){}
return w;
}
function rectangleBackingMode(){
const n=lineCount();
if(n===1){
const t=(inputs[0].value.trim()||previews[0].textContent||'').replace(/[^A-Za-z]/g,'');
return t.length>0&&t===t.toUpperCase();
}
let w=[];
for(let i=0;i<n;i++)w.push(actualLineWidth(i));
return Math.min.apply(null,w)/Math.max.apply(null,w)>=.82;
}
function roundedRect(g,x,y,w,h,r){
r=Math.min(r,w/2,h/2);g.beginPath();g.moveTo(x+r,y);g.lineTo(x+w-r,y);g.quadraticCurveTo(x+w,y,x+w,y+r);g.lineTo(x+w,y+h-r);g.quadraticCurveTo(x+w,y+h,x+w-r,y+h);g.lineTo(x+r,y+h);g.quadraticCurveTo(x,y+h,x,y+h-r);g.lineTo(x,y+r);g.quadraticCurveTo(x,y,x+r,y);g.closePath();g.fill();
}
function makeBackingShape(){
const bw=board.offsetWidth;
const bh=board.offsetHeight;
const d=2;
const br=board.getBoundingClientRect();
const scale=br.width/bw||1;
const n=lineCount();

const a=document.createElement('canvas');
a.width=bw*d;
a.height=bh*d;

const g=a.getContext('2d');
g.setTransform(d,0,0,d,0,0);
g.fillStyle='#fff';

/*
  Stable preview backing:
  one rounded rectangle around the overall lettering block.
  This intentionally avoids the mobile Safari cut-to-shape canvas issues.
*/
let maxW=0;
let T=bh;
let B=0;

for(let i=0;i<n;i++){
  const b=previews[i].getBoundingClientRect();

  maxW=Math.max(
    maxW,
    actualLineWidth(i)
  );

  T=Math.min(
    T,
    (b.top-br.top)/scale
  );

  B=Math.max(
    B,
    (b.bottom-br.top)/scale
  );
}

/*
  Keep the rectangle fairly tight to the text while leaving enough acrylic
  margin to look realistic and consistent at every screen size.
*/
const padX=20;
const padY=16;

const L=Math.max(
  10,
  (bw-maxW)/2-padX
);

const R=Math.min(
  bw-10,
  (bw+maxW)/2+padX
);

T=Math.max(
  10,
  T-padY
);

B=Math.min(
  bh-10,
  B+padY
);

roundedRect(
  g,
  L,
  T,
  R-L,
  B-T,
  12
);

return{
  canvas:a,
  w:bw,
  h:bh,
  d:d
};
}
function paintBacking(){
if(backingFrame)cancelAnimationFrame(backingFrame);
backingFrame=requestAnimationFrame(function(){
const z=makeBackingShape(),c=backingCanvas,d=window.devicePixelRatio||1,g=c.getContext('2d');
c.width=z.w*d;c.height=z.h*d;c.style.width=z.w+'px';c.style.height=z.h+'px';g.setTransform(d,0,0,d,0,0);g.clearRect(0,0,z.w,z.h);
function paint(fill){const q=document.createElement('canvas');q.width=c.width;q.height=c.height;const x=q.getContext('2d');x.drawImage(z.canvas,0,0,q.width,q.height);x.globalCompositeOperation='source-in';x.fillStyle=fill;x.fillRect(0,0,q.width,q.height);g.drawImage(q,0,0,z.w,z.h)}
if(state.backing==='Glossy Black'){const gr=g.createLinearGradient(0,0,z.w,z.h);gr.addColorStop(0,'#333');gr.addColorStop(.18,'#111');gr.addColorStop(.72,'#050505');gr.addColorStop(1,'#222');paint(gr)}
else if(state.backing==='Glossy White'){const gr=g.createLinearGradient(0,0,z.w,z.h);gr.addColorStop(0,'#fff');gr.addColorStop(.65,'#f4f4f4');gr.addColorStop(1,'#dadada');paint(gr)}
else paint('rgba(255,255,255,.055)');
backingFrame=null
})
}

function updateBoard(){
board.className =
'lgw-sign-board ' +
state.backingClass +
' lines-' +
lineCount();
scalePreviewBoard();
paintBacking();
}
function fitText(){
if(fitFrame){
cancelAnimationFrame(
fitFrame
);
}
fitFrame =
requestAnimationFrame(function(){
const total =
lineCount();
const baseTargetSize =
total === 1 ? 98 :
total === 2 ? 77 :
61;
const innerWidth =
656;
const maxTextWidth =
innerWidth * .92;
previews.forEach(function(line, index){
if(index >= total){
return;
}
const text =
line.textContent ||
'YOUR TEXT';
const hasDescender =
/[fgGjJpqQyY]/.test(text);
const hasCursiveDescender =
/[fgGjJpqyYz]/.test(text);
const isCursive =
state.fonts[index].name === 'Cursive';
const isScript =
state.fonts[index].name === 'Script';
const sizeScale =
state.sizes[index] / 100;
const targetSize =
(
isCursive ?
baseTargetSize * 1.18 :
isScript ?
baseTargetSize * 0.82 :
baseTargetSize
) * sizeScale;
const widthStretch =
isCursive ?
1.08 :
1;
measurementContext.font =
'500 ' +
targetSize +
'px ' +
state.fonts[index].family;
const measurement =
measurementContext
.measureText(text);
const measuredWidth =
(
measurement.width +
(targetSize * .22)
) * widthStretch;
let finalSize =
targetSize;
if(
measuredWidth >
maxTextWidth
){
finalSize =
targetSize *
(
maxTextWidth /
measuredWidth
);
}
finalSize =
finalSize * .97;
const minimumSize =
23;
finalSize =
Math.max(
minimumSize,
finalSize
);
line.style.fontSize =
Math.floor(
finalSize
) + 'px';
if(isCursive && !hasCursiveDescender){
line.style.transform =
'scaleX(1.08) translateY(.12em)';
line.style.transformOrigin =
'center center';
}else if(isCursive){
line.style.transform =
'scaleX(1.08) translateY(-.08em)';
line.style.transformOrigin =
'center center';
}else if(state.fonts[index].name === 'Audiowide'){
line.style.transform =
'scaleX(.82)';
line.style.transformOrigin =
'center center';
}else{
line.style.transform =
'none';
}
if(isScript && hasDescender){
  line.style.lineHeight = '1.28';
}else if(isScript){
  line.style.lineHeight = '.98';
}else if(isCursive && hasCursiveDescender){
  line.style.lineHeight = '1.10';
}else if(state.fonts[index].name === 'Sleek'){
  line.style.lineHeight = '1.03';
}else{
  line.style.lineHeight = '.93';
}
});
previewText.style.visibility =
'visible';
paintBacking();
fitFrame =
null;
});
}
function updateText(){
const total =
lineCount();
wrappers[1].style.display =
total >= 2 ?
'block' :
'none';
wrappers[2].style.display =
total >= 3 ?
'block' :
'none';
for(let i = 1; i <= 3; i++){
const show = i <= total;
document.getElementById('lgw-font-wrap-' + i).style.display = show ? 'block' : 'none';
document.getElementById('lgw-color-wrap-' + i).style.display = show ? 'block' : 'none';
}
previews.forEach(function(preview, index){
if(index < total){
preview.style.display =
'block';
const value =
inputs[index]
.value
.trim();
preview.textContent =
value ||
(
index === 0 ?
'YOUR TEXT' :
'LINE ' +
(index + 1)
);
}else{
preview.style.display =
'none';
}
});
inputs.forEach(function(input, index){
counters[index].textContent =
input.value.length;
});
updateBoard();
fitText();
}
function updateFont(){
previews.forEach(function(preview, index){
preview.style.fontFamily = state.fonts[index].family;

if(state.fonts[index].name === 'Script'){
  preview.style.letterSpacing = '0.04em';
}else{
  preview.style.letterSpacing = '0';
}
preview.style.fontWeight =
(state.fonts[index].name === 'Script' ||
 state.fonts[index].name === 'Audiowide') ? '400' : '500';

preview.style.fontSynthesis =
(state.fonts[index].name === 'Script' ||
 state.fonts[index].name === 'Audiowide') ? 'none' : 'auto';
if(state.fonts[index].name === 'Sleek'){
const isMobile =
window.matchMedia('(max-width: 700px)').matches;

preview.style.webkitTextStroke =
isMobile ?
'0.4px currentColor' :
'0.6px currentColor';

}else if(state.fonts[index].name === 'Cursive'){

preview.style.webkitTextStroke =
'0';

}else{

preview.style.webkitTextStroke =
'0';

}
});
fitText();
updateGlow();
}

function updateGlow(){
function hexToRgb(hex){
const clean =
hex.replace('#', '');
const full =
clean.length === 3 ?
clean.split('').map(function(char){
return char + char;
}).join('') :
clean;
const value =
parseInt(full, 16);
return {
r: (value >> 16) & 255,
g: (value >> 8) & 255,
b: value & 255
};
}

function rgba(rgb, alpha){
return 'rgba(' +
rgb.r + ',' +
rgb.g + ',' +
rgb.b + ',' +
alpha +
')';
}

const colorGlowScale = {
'White': .92,
'Red': 1.00,
'Blue': 1.32,
'Green': 1.00,
'Pink': 1.03,
'Purple': 1.04,
'Orange': .98,
'Yellow': .94,
'Ice Blue': 1.00,
'Golden': .96
};

previews.forEach(function(preview, index){
const lineColor =
state.colors[index].value;
const colorName =
state.colors[index].name;
const rgb =
hexToRgb(lineColor);

const colorScale =
colorGlowScale[colorName] || 1;

const glowScale =
2.15 * colorScale;

const inner1 =
Math.max(
0.9,
1.3 * glowScale
);

const inner2 =
Math.max(
1.8,
3.4 * glowScale
);

const middle =
Math.max(
6,
12.5 * glowScale
);

const outer =
Math.max(
12,
24 * glowScale
);

const halo =
Math.max(
22,
41 * glowScale
);

const farHalo =
Math.max(
34,
62 * glowScale
);

let coreColor =
'rgba(255,255,255,.70)';

if(colorName === 'Yellow'){
coreColor =
'rgba(255,255,235,.98)';
}else if(
colorName === 'Orange' ||
colorName === 'Golden'
){
coreColor =
'rgba(255,246,225,.84)';
}else if(colorName === 'Red'){
coreColor =
'rgba(255,236,236,.72)';
}else if(colorName === 'Green'){
coreColor =
'rgba(238,255,241,.98)';
}else if(colorName === 'Blue'){
coreColor =
'rgba(210,235,255,.72)';
}else if(colorName === 'Ice Blue'){
coreColor =
'rgba(240,253,255,.99)';
}else if(colorName === 'Pink'){
coreColor =
'rgba(255,239,249,.78)';
}else if(colorName === 'Purple'){
coreColor =
'rgba(248,239,255,.72)';
}

preview.style.color =
lineColor;

/*
  Sleek on iPhone/mobile Safari:
  keep the tube core fully bright, but use a much smaller halo so it looks
  illuminated instead of blurry. Desktop and every other font stay unchanged.
*/
const sleekMobile =
state.fonts[index].name === 'Sleek' &&
window.matchMedia('(max-width: 700px)').matches;

preview.style.opacity = '1';

if(sleekMobile){

  preview.style.textShadow =
  '0 0 1.5px ' +
  coreColor +
  ',' +
  '0 0 4px ' +
  rgba(rgb,.90) +
  ',' +
  '0 0 9px ' +
  rgba(rgb,.62) +
  ',' +
  '0 0 17px ' +
  rgba(rgb,.38) +
  ',' +
  '0 0 29px ' +
  rgba(rgb,.20);

}else{

  preview.style.textShadow =
  '0 0 ' +
  inner1.toFixed(1) +
  'px ' +
  coreColor +
  ',' +
  '0 0 ' +
  inner2.toFixed(1) +
  'px ' +
  rgba(rgb, .98) +
  ',' +
  '0 0 ' +
  middle.toFixed(1) +
  'px ' +
  rgba(rgb, .88) +
  ',' +
  '0 0 ' +
  outer.toFixed(1) +
  'px ' +
  rgba(rgb, .66) +
  ',' +
  '0 0 ' +
  halo.toFixed(1) +
  'px ' +
  rgba(rgb, .42) +
  ',' +
  '0 0 ' +
  farHalo.toFixed(1) +
  'px ' +
  rgba(rgb, .22);
}
});
}

function updateAll(){
updateBoard();
updateText();
updateFont();
updateGlow();
updateVariant();
limits(state.width);
}
document
.querySelectorAll(
'#lgw-line-buttons .lgw-choice'
)
.forEach(function(button){
button.addEventListener(
'click',
function(){
setSelected(
'#lgw-line-buttons .lgw-choice',
button
);
state.lines =
button.dataset.value;
updateText();
updateVariant();
limits(state.width);
}
);
});
document
.querySelectorAll(
'#lgw-width-buttons .lgw-choice'
)
.forEach(function(button){
button.addEventListener(
'click',
function(){
setSelected(
'#lgw-width-buttons .lgw-choice',
button
);
state.width =
button.dataset.value;
updateVariant();
limits(state.width);
}
);
});
inputs.forEach(function(input){
input.addEventListener('input',function(){updateText();updateVariant();limits(state.width);});
});
sizeSliders.forEach(function(slider, index){
slider.addEventListener(
'input',
function(){
state.sizes[index] =
parseInt(slider.value, 10) || 100;
sizeValues[index].textContent =
state.sizes[index] + '%';
fitText();
}
);
});
document
.querySelectorAll('.lgw-font')
.forEach(function(button){
button.addEventListener(
'click',
function(){
const lineIndex =
parseInt(button.dataset.line, 10) - 1;
const grid =
button.closest('.lgw-font-grid');
grid
.querySelectorAll('.lgw-font')
.forEach(function(item){
item.classList.remove('selected');
});
button.classList.add('selected');
state.fonts[lineIndex] = {
name: button.dataset.name,
family: button.dataset.family
};
updateFont();
}
);
});
document
.querySelectorAll('.lgw-color')
.forEach(function(button){
button.addEventListener(
'click',
function(){
const lineIndex =
parseInt(button.dataset.line, 10) - 1;
const grid =
button.closest('.lgw-color-grid');
grid
.querySelectorAll('.lgw-color')
.forEach(function(item){
item.classList.remove('selected');
});
button.classList.add('selected');
state.colors[lineIndex] = {
name: button.dataset.name,
value: button.dataset.color
};
updateGlow();
}
);
});
document
.querySelectorAll('.lgw-backing')
.forEach(function(button){
button.addEventListener(
'click',
function(){
setSelected(
'.lgw-backing',
button
);
state.backing =
button.dataset.name;
state.backingClass =
button.dataset.class;
updateBoard();
}
);
});
document
.querySelectorAll('.lgw-mounting')
.forEach(function(button){
button.addEventListener(
'click',
function(){
setSelected(
'.lgw-mounting',
button
);
state.mounting =
button.dataset.name;
}
);
});
document
.getElementById('lgw-minus')
.addEventListener(
'click',
function(){
let value =
parseInt(
quantity.value,
10
) || 1;
quantity.value =
Math.max(
1,
value - 1
);
}
);
document
.getElementById('lgw-plus')
.addEventListener(
'click',
function(){
let value =
parseInt(
quantity.value,
10
) || 1;
quantity.value =
value + 1;
}
);
addButton.addEventListener(
'click',
async function(){
message.textContent =
'';
const total =
lineCount();
for(
let i = 0;
i < total;
i++
){
if(
!inputs[i]
.value
.trim()
){
message.style.color =
'#a00';
message.textContent =
'Please enter text for Line ' +
(i + 1) +
'.';
inputs[i].focus();
return;
}
}
const variant =
findVariant();
if(!variant){
message.style.color =
'#a00';
message.textContent =
'This size and line combination is unavailable.';
return;
}
if(!variant.available){
message.style.color =
'#a00';
message.textContent =
'This option is currently unavailable.';
return;
}
const properties = {
'Custom Text - Line 1': inputs[0].value.trim()
};
if(total >= 2){
properties['Custom Text - Line 2'] =
inputs[1].value.trim();
}
if(total >= 3){
properties['Custom Text - Line 3'] =
inputs[2].value.trim();
}
properties['Font - Line 1'] = state.fonts[0].name;
properties['Font Size - Line 1'] = state.sizes[0] + '%';
properties['LED Color - Line 1'] = state.colors[0].name;
if(total >= 2){
properties['Font - Line 2'] = state.fonts[1].name;
properties['Font Size - Line 2'] = state.sizes[1] + '%';
properties['LED Color - Line 2'] = state.colors[1].name;
}
if(total >= 3){
properties['Font - Line 3'] = state.fonts[2].name;
properties['Font Size - Line 3'] = state.sizes[2] + '%';
properties['LED Color - Line 3'] = state.colors[2].name;
}
properties['Backing'] = state.backing;
properties['Mounting'] = state.mounting;
properties['View Customer Design'] =
buildCustomerDesignUrl(total);
if(total >= 2){
properties[
'Custom Text - Line 2'
] =
inputs[1]
.value
.trim();
}
if(total >= 3){
properties[
'Custom Text - Line 3'
] =
inputs[2]
.value
.trim();
}
const qty =
Math.max(
1,
parseInt(
quantity.value,
10
) || 1
);
addButton.disabled =
true;
addButton.textContent =
'Adding...';
try{
const response =
await fetch(
'/cart/add.js',
{
method: 'POST',
headers: {
'Content-Type':
'application/json',
'Accept':
'application/json'
},
body:
JSON.stringify({
items: [
{
id:
variant.id,
quantity:
qty,
properties:
properties
}
]
})
}
);
if(!response.ok){
throw new Error();
}
addButton.textContent =
'Added!';
window.location.href =
'/cart';
}catch(error){
addButton.disabled =
false;
addButton.textContent =
'Add to Cart';
message.style.color =
'#a00';
message.textContent =
'Unable to add your custom sign to the cart. Please try again.';
}
}
);
let resizeTimer;
window.addEventListener(
'resize',
function(){
clearTimeout(
resizeTimer
);
resizeTimer =
setTimeout(
function(){
scalePreviewBoard();
fitText();
updateGlow();
paintBacking();
},
150
);
}
);
restoreCustomerDesignFromUrl();

if(
document.fonts &&
document.fonts.ready
){
document.fonts.ready.then(
function(){
updateAll();
setTimeout(
fitText,
50
);
}
);
}else{
updateAll();
}
})();